export const environment = {
    DefaultLanguage: "en",
    production: false,
    development: true,
    environmentName: "DEV",
    baseURL: "http://localhost:1941/",
    API_URL: 'https://secure2.grammarin.com', // environment.API_URL+
    CaptchaKey: '1x00000000000000000000AA', // environment.CaptchaKey
    AuthorizationGIN: 'Bearer 2685bb3a2ffc6eabccc3b6ebbfee886cd2d7061e',
    drive: {
        developerKey: 'AIzaSyDG1HJnwaQxH3eba59D-dB7a31N9PPMhBA',
        clientId: '859452103362-3aroha97qk7nt8ps6ocl70k10pj7uuvt.apps.googleusercontent.com',
        scope: 'profile email https://www.googleapis.com/auth/drive.file',
    }
};

export const GINConstants = { key: 'value' }; // console.log(GINConstants.key);